const CallbackOptions = {
	onConnected: "onConnected",
	hello: "hello",
	assemblyUpdate: "AssemblyUpdated",
	dealerSignup: "DealerSignup",
};

export default CallbackOptions;
